import { render, staticRenderFns } from "./backoffice-cadastro-medico.vue?vue&type=template&id=4590d223&scoped=true"
import script from "./backoffice-cadastro-medico.vue?vue&type=script&lang=ts"
export * from "./backoffice-cadastro-medico.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-cadastro-medico.vue?vue&type=style&index=0&id=4590d223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4590d223",
  null
  
)

export default component.exports